import { Fragment } from 'react';

export function Viruses() {
  return (
    <Fragment>
      You must not misuse our site by knowingly introducing viruses, trojans, worms, logic bombs or other material which is malicious or technologically harmful. You must not attempt to gain unauthorised access to our site, the server on which our site is stored or any server, computer or database connected to our site. You must not attack our site via a denial-of-service attack or a distributed denial-of service attack. 
      <br /><br />
      By breaching this provision, you would commit a criminal offence under the Computer Misuse Act 1990. We may report any such breach to the relevant law enforcement authorities, and we will cooperate with those authorities by disclosing your identity to them. In the event of such a breach, your right to use our site will cease immediately. 
      <br /><br />
      We will not be liable for any loss or damage caused by a distributed denial-of-service attack, viruses, or other technologically harmful material that may infect your computer equipment, computer programs, data or other proprietary material due to your use of our site or to your downloading of any material posted on it, or on any website linked to it.
    </Fragment>
  );
}


export default Viruses;
